import type {
	Categories,
	Category,
	CategoryGuid,
} from '@atlassian/jira-servicedesk-knowledge-services/src/types.tsx';
import type { State } from '../../types.tsx';

export const getCategory = (state: State, id: CategoryGuid): Category | undefined =>
	state.entities.categories.categories.find((category) => category.id === id);

export const getCategoryName = (state: State, id: CategoryGuid): string | undefined => {
	const category = getCategory(state, id);
	if (category) {
		return category.name;
	}

	return undefined;
};

export const getAllCategories = (state: State): Categories => state.entities.categories.categories;
